export const EMAIL_CHECK =
  /^[a-z0-9]((\.|\+|-|_)?[a-z0-9]){1,}@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
